import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@elaniintc/goes-design-system";
import { useUIStore } from "@/workflow_api/store/uiStore";

interface Props {
  isOpen: boolean;
  children?: React.ReactNode;
  isSaveValid?: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onDirectClose?: () => void; // Cierre directo sin confirmación (usado cuando está bloqueado)
  onSave?: () => void;
  actionLabel?: string;
}

const FullModal = ({
  isOpen,
  children,
  isSaveValid,
  isLoading,
  onClose,
  onDirectClose,
  onSave,
  actionLabel = "Guardar",
}: Props) => {
  const { isFlowBlocked, setNodeDetailsOpen, setSelectedNodeId, setModalState } = useUIStore();

  const handleClose = () => {
    // Si está bloqueado, cerrar directamente sin confirmación
    if (isFlowBlocked) {
      if (onDirectClose) {
        onDirectClose();
      } else {
        // Comportamiento por defecto: cerrar el modal de detalles directamente
        setNodeDetailsOpen(false);
        setSelectedNodeId(undefined);
        setModalState("idle");
      }
    } else {
      // Comportamiento normal: mostrar confirmación
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => { }}>
      <DialogTitle className="sr-only">Action modal</DialogTitle>
      <DialogDescription className="sr-only">
        Complete the action in the modal
      </DialogDescription>
      <DialogContent
        showCloseButton={false}
        type="full"
        data-testid="full-modal"
        controlers={
          <>
            <Button
              type="button"
              variant="alpha-neutral"
              className="border-neutral-alpha-quiet"
              size="xs"
              onClick={handleClose}
              data-testid="close-btn"
            >
              {isFlowBlocked ? "Cerrar" : "Cancelar"}
            </Button>
            <Button
              type="button"
              variant="default"
              size="xs"
              onClick={onSave}
              disabled={!isSaveValid || isFlowBlocked}
              isLoading={isLoading}
              data-testid="save-btn"
            >
              {actionLabel}
            </Button>
          </>
        }
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default FullModal;
